import { getApp, getApps, initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, type AppCheck } from "firebase/app-check";
import {
  connectAuthEmulator,
  initializeAuth,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  browserSessionPersistence,
  browserPopupRedirectResolver,
} from "firebase/auth";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

const localHost = ["127.0.0.1", "localhost"].includes(window.location.hostname);
const demoProjectId = "demo-sidequest-hq";
const projectId = localHost ? demoProjectId : (import.meta.env.VITE_FIREBASE_PROJECT_ID || demoProjectId);
const firebaseConfig = {
  apiKey: localHost ? "demo-sidequest-hq-key" : (import.meta.env.VITE_FIREBASE_API_KEY || "demo-sidequest-hq-key"),
  authDomain: localHost ? `${demoProjectId}.firebaseapp.com` : (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || `${projectId}.firebaseapp.com`),
  projectId,
  storageBucket: localHost ? `${demoProjectId}.firebasestorage.app` : (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || `${projectId}.firebasestorage.app`),
  appId: localHost ? "1:123456789:web:sidequesthq" : (import.meta.env.VITE_FIREBASE_APP_ID || "1:123456789:web:sidequesthq"),
};
const localAppName = "sidequest-local";
export const firebaseApp = localHost
  ? (getApps().find((candidate) => candidate.name === localAppName) || initializeApp(firebaseConfig, localAppName))
  : (getApps().length ? getApp() : initializeApp(firebaseConfig));

// Callable enforcement is disabled only by the Functions emulator. Production
// releases must include the registered Enterprise site key (validated in CI).
export let appCheck: AppCheck | undefined;
if (!localHost && import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY) {
  appCheck = initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_RECAPTCHA_ENTERPRISE_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

// Restore from the same storage used to save the session. The default getAuth
// order migrates localStorage sessions to IndexedDB; switching persistence back
// afterward makes that copy happen on every refresh. Keep the other stores as
// fallbacks so existing sessions and browsers with restricted storage still work.
export const auth = initializeAuth(firebaseApp, {
  persistence: [browserLocalPersistence, indexedDBLocalPersistence, browserSessionPersistence],
  popupRedirectResolver: browserPopupRedirectResolver,
});
export const functions = getFunctions(firebaseApp, "australia-southeast1");

const emulatorKey = "__sidequest_demo_emulators_connected__";
const emulatorScope = globalThis as typeof globalThis & Record<string, boolean>;

if (localHost && !emulatorScope[emulatorKey]) {
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  emulatorScope[emulatorKey] = true;
}
